import React, { forwardRef, useRef, useState } from "react";

import EventNotes from "../EventNotes";
import ChangeQuarterAndTime from "../ChangeQuarterAndTime";
import ChangeTeams from "../ChangeTeams";
import ChangeEventType from "../ChangeEventType";
import SelectChangePlayers from "../SelectChangePlayers";
import TypeOfEventType from "../TypeOfEventType";
import Header from "../Header";
import ConfirmButton from "../ConfirmButton";
import Submit from "../HandleSubmit";

const handleSubmit = (diff, event, matchId, matchData, setMatchData) => {
    const { type, team, player, newQuarter, goalPostType, newComment } = diff;
    let update = {};

    if (type === "GELB") {
        update = {
            ...update,
            type: "Cards",
            postType: 10,
        };
    }
    if (type === "ROT") {
        update = {
            ...update,
            type: "Cards",
            postType: 12,
        };
    }
    if (type === "GRÜN") {
        update = {
            ...update,
            type: "Cards",
            postType: 11,
        };
    }
    if (team) {
        update = {
            ...update,
            team,
            player,
        };
    }
    if (player) {
        update = {
            ...update,
            scorerContact: player,
        };
    }
    if (newQuarter) {
        let quarter = "";
        switch (newQuarter) {
            case "Q1":
                quarter = 1;
                break;
            case "Q2":
                quarter = 2;
                break;
            case "Q3":
                quarter = 3;
                break;
            case "Q4":
                quarter = 4;
                break;
        }
        update = {
            ...update,
            quarter,
        };
    }

    if (type === "GOAL" || diff.hasOwnProperty("goalPostType")) {
        let postType = "";
        switch (goalPostType) {
            case 0:
                postType = 9;
                break;
            case 1:
                postType = 18;
                break;
            case 2:
                postType = 19;
                break;
        }
        update = {
            ...update,
            type: "Goals",
            postType,
        };
    }

    if (typeof newComment === "string") {
        update = {
            ...update,
            additionalData: newComment,
        };
    }

    update = {
        matchPosts: matchData.matchPosts.map((post) => {
            if (event.id === post.id) {
                return {
                    ...post,
                    ...update,
                    minute: Math.ceil(event.timestamp / 60),
                    isChanged: true,
                };
            }
            return post;
        }),
    };

    Submit(matchId, matchData, update, setMatchData);
};

const EditGoalEvent = forwardRef(
    (
        {
            setIsEditModalOpen,
            sides,
            eventDetailsToEdit,
            setEventDetailsToEdit,
            EVENT_TYPES,
            GOAL_TYPES,
            setEventsToShow,
            setSides,
            goals,
            setGoals,
            isEditing,
            setIsEditing,
            matchData,
            matchId,
            setMatchData,
            quarterSelected,
        },
        ref
    ) => {
        const initialState = useRef(eventDetailsToEdit);

        let showDoneButton = false;
        const [confirmButton, setConfirmButton] = useState(false);

        let diff = {};
        if (
            initialState.current.quarterSelected !==
            eventDetailsToEdit.quarterSelected
        ) {
            diff = {
                ...diff,
                newQuarter: eventDetailsToEdit.quarterSelected,
            };
            showDoneButton = true;
        }

        if (
            initialState.current.eventNotes?.trim() !==
            eventDetailsToEdit.eventNotes?.trim()
        ) {
            diff = {
                ...diff,
                newComment: eventDetailsToEdit.eventNotes?.trim(),
            };
            showDoneButton = true;
        }

        if (
            initialState.current.playerSelected?.id !==
                eventDetailsToEdit.playerSelected?.id &&
            eventDetailsToEdit.playerSelected
        ) {
            diff = {
                ...diff,
                player: eventDetailsToEdit.playerSelected?.id,
            };
            showDoneButton = true;
        }

        if (
            initialState.current.sideSelected.id !==
                eventDetailsToEdit.sideSelected?.id &&
            eventDetailsToEdit.sideSelected
        ) {
            diff = {
                ...diff,
                team: eventDetailsToEdit.sideSelected.id,
            };
            showDoneButton = true;
        }

        if (
            initialState.current.type.name !== eventDetailsToEdit.type?.name &&
            eventDetailsToEdit.type
        ) {
            diff = {
                ...diff,
                type: eventDetailsToEdit.type.name,
            };
            showDoneButton = true;
        }

        if (
            eventDetailsToEdit?.type?.name === "GOAL" &&
            eventDetailsToEdit?.typeOfEventTypeSelected &&
            eventDetailsToEdit?.typeOfEventTypeSelected?.id !==
                initialState?.current.typeOfEventTypeSelected?.id
        ) {
            diff = {
                ...diff,
                goalPostType: eventDetailsToEdit.typeOfEventTypeSelected.id,
            };
            showDoneButton = true;
        }

        if (diff.type === "GOAL" && !diff.hasOwnProperty("goalPostType")) {
            showDoneButton = false;
        }

        if (diff.team && !diff.hasOwnProperty("player")) {
            showDoneButton = false;
        }
        return (
            <div
                ref={ref}
                style={{
                    backgroundColor: "#E5E5E5",
                }}
            >
                <Header
                    eventDetails={eventDetailsToEdit}
                    setEventDetails={setEventDetailsToEdit}
                    setModalOpen={setIsEditModalOpen}
                    isEditing={isEditing}
                    setEventsToShow={setEventsToShow}
                    matchData={matchData}
                    matchId={matchId}
                    setMatchData={setMatchData}
                />

                {quarterSelected !== "SO" && (
                    <ChangeQuarterAndTime
                        eventDetails={eventDetailsToEdit}
                        setEventDetails={setEventDetailsToEdit}
                        matchId={matchId}
                        setMatchData={setMatchData}
                        matchData={matchData}
                        setEventsToShow={setEventsToShow}
                        setConfirmButton={setConfirmButton}
                    />
                )}
                <ChangeTeams
                    sides={sides}
                    setSides={setSides}
                    setGoals={setGoals}
                    eventDetails={eventDetailsToEdit}
                    setEventDetails={setEventDetailsToEdit}
                />
                {quarterSelected !== "SO" && (
                    <ChangeEventType
                        EVENT_TYPES={EVENT_TYPES}
                        eventDetails={eventDetailsToEdit}
                        setEventDetails={setEventDetailsToEdit}
                        preventChange={true}
                    />
                )}
                <SelectChangePlayers
                    eventDetails={eventDetailsToEdit}
                    setEventDetails={setEventDetailsToEdit}
                    initialEvent={initialState}
                />
                {quarterSelected !== "SO" && (
                    <TypeOfEventType
                        GOAL_TYPES={
                            eventDetailsToEdit.type?.name === "GOAL"
                                ? GOAL_TYPES
                                : null
                        }
                        eventDetails={eventDetailsToEdit}
                        setEventDetails={setEventDetailsToEdit}
                        editModal={true}
                    />
                )}
                <EventNotes
                    textAreaValue={eventDetailsToEdit?.eventNotes}
                    showConfirmCancelButtons={
                        !!eventDetailsToEdit?.eventNotes?.length
                    }
                    confirmButtonAction={() => {}}
                    cancelButtonAction={() => {
                        setEventDetailsToEdit((data) => ({
                            ...data,
                            eventNotes: "",
                        }));
                    }}
                    onChange={(e) => {
                        setEventDetailsToEdit((data) => ({
                            ...data,
                            eventNotes: e.target.value,
                        }));
                    }}
                />

                {showDoneButton || confirmButton ? (
                    <ConfirmButton
                        action={() => {
                            handleSubmit(
                                diff,
                                eventDetailsToEdit,
                                matchId,
                                matchData,
                                setMatchData
                            );
                            setEventsToShow((data) => {
                                return [
                                    ...data?.map((item) => {
                                        if (
                                            item?.id === eventDetailsToEdit?.id
                                        ) {
                                            return eventDetailsToEdit;
                                        } else return item;
                                    }),
                                ];
                            });
                            setIsEditing(false);
                            setIsEditModalOpen(false);
                        }}
                    />
                ) : null}
            </div>
        );
    }
);

export default EditGoalEvent;
